import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import createReactClass from 'create-react-class'

import s from './sticky-block.module.scss'

export default createReactClass({
  displayName: 'StickyBlock',

  propTypes: {
    parent: PropTypes.any,
    children: PropTypes.node.isRequired,
    stickToBottom: PropTypes.bool,
    stickyOnlyIfBiggerThanWindow: PropTypes.bool,
  },

  contextTypes: {
    modal: PropTypes.any,
  },

  getInitialState() {
    return {
      isSticky: false,
      isFixedToBottom: false,
    }
  },

  componentDidMount() {
    const parentElement = this.context.modal || window

    parentElement.addEventListener('scroll', this.stickMenu, false)
  },

  componentWillUnmount() {
    const parentElement = this.context.modal || window

    parentElement.removeEventListener('scroll', this.stickMenu)
  },

  previousScroll: 0,

  stickMenu() {
    const scrollTop = this.context.modal
      ? this.context.modal.scrollTop
      : window.pageYOffset
    const offsetTop = this.container.offsetTop
    const blockHeight = this.inner.offsetHeight
    const parentHeight = this.props.parent ? this.props.parent.offsetHeight : 0
    const windowHeight = window.innerHeight
    let indent

    if (
      this.props.stickyOnlyIfBiggerThanWindow &&
      parentHeight < windowHeight
    ) {
      return null
    }

    if (!this.state.isSticky && this.context.modal) {
      this.sticky.style.top = 0
    }

    indent = scrollTop - this.previousScroll
    this.previousScroll = scrollTop

    if (this.props.stickToBottom) {
      const stickyBlockBottom = scrollTop + blockHeight
      const parentBottom = offsetTop + parentHeight

      if (stickyBlockBottom >= parentBottom && !this.state.isFixedToBottom) {
        this.container.style.height = `${parentHeight}px`
        this.setState({ isFixedToBottom: true })

        if (this.context.modal) {
          this.sticky.style.top = 'auto'
        }
      }

      if (stickyBlockBottom < parentBottom) {
        this.container.style.height = 'auto'
        this.setState({ isFixedToBottom: false })
      }
    }

    if (scrollTop >= offsetTop && !this.state.isSticky) {
      this.setState({ isSticky: true })
    }

    if (scrollTop < offsetTop && this.state.isSticky) {
      this.setState({ isSticky: false })
    }

    if (blockHeight > windowHeight && this.state.isSticky) {
      this.sticky.scrollTop += indent
    }

    if (
      this.state.isSticky &&
      this.context.modal &&
      !this.state.isFixedToBottom
    ) {
      this.sticky.style.top = `${scrollTop - offsetTop}px`
    }

    return null
  },

  render() {
    return (
      <div
        className={classNames(s.container, {
          [s._fixed]: this.state.isSticky && !this.context.modal,
          [s._absolute]: this.state.isSticky && this.context.modal,
          [s._bottom]: this.state.isFixedToBottom,
        })}
        ref={(ref) => (this.container = ref)}
      >
        <div className={s.sticky} ref={(ref) => (this.sticky = ref)}>
          <div className={s.inner} ref={(ref) => (this.inner = ref)}>
            {this.props.children}
          </div>
        </div>
      </div>
    )
  },
})
